import { SELECT_BILL_DATE, CLEAR_BILL_DATE } from '../actions/billing/selectBillingDate';

const initialState = {
  selectedBillDate: null,
  adjustmentDays: null,
};

export default (state = initialState, action = {}) => {
  if (action.type === SELECT_BILL_DATE) {
    return {
      ...state,
      selectedBillDate: action.payload?.selectedBillDate,
      adjustmentDays: action.payload?.adjustmentDays,
    };
  }
  if (action.type === CLEAR_BILL_DATE) {
    return initialState;
  }
  return state;
};
